import { usePurchaseButtonContext } from './Context'
import { BusyButtonLink } from '@ztechapps/webui.button'
import { Modal as ModalCore } from 'react-bootstrap'
import { Modal, ModalDragHandle } from '@ztechapps/webui.modal'
import { ShowIf } from '@ztechapps/webui.util'
import { Stack } from 'react-bootstrap'
import { Confirm } from './Confirm'
import React from 'react'
import { PopupHeader } from './PopupHeader'
import { NewPurchaseOrder } from './NewPurchaseOrder'
import { ExistingPurchaseOrder } from './ExistingPurchaseOrder'

export const Layout = () => {
  const { showConfirm } = usePurchaseButtonContext()
  return (
    <Modal
      centered
      size="md"
      trigger={({ onClick }) => (
        <BusyButtonLink onClick={onClick} icon="cart-shopping" title="Add this product to purchase order." />
      )}
    >
      {({ toggleShowModal }) => (
        <>
          <ShowIf condition={!showConfirm}>
            <ModalDragHandle>Add new or include in existing purchase order</ModalDragHandle>

            <ModalCore.Body>
              <Stack gap={2}>
                <PopupHeader />
                <Stack gap={2}>
                  <NewPurchaseOrder />
                  <ExistingPurchaseOrder />
                </Stack>
              </Stack>
            </ModalCore.Body>
          </ShowIf>

          <ShowIf condition={showConfirm}>
            <Confirm toggleShowModal={toggleShowModal} />
          </ShowIf>
        </>
      )}
    </Modal>
  )
}
